import {
  ChangeDetectionStrategy,
  Component,
  computed,
  EventEmitter,
  inject,
  Input,
  OnInit,
  Output,
  signal,
} from '@angular/core';
import { FichajeSessionEvent } from 'src/app/shared/interfaces/session-event.interface';
import { AuthService, FichajeService } from 'src/app/shared/services';
import { DeviceService } from '../../services/device.service';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-fichaje-endwork',
  imports: [ButtonModule],
    providers: [MessageService],
  templateUrl: './fichaje-endwork.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FichajeEndworkComponent implements OnInit{
  @Input() lastFichaje: FichajeSessionEvent;
  @Input() id: string;
  @Output() onDrawerlose = new EventEmitter<boolean>();

  fichando = false;
  location = '';
  ip = '';
  deviceInfo = '';
  public isUploading = false;
  horaActual = new Date();

  public isLoading = signal<boolean>(true);

  private fichajeService = inject(FichajeService);
  private deviceService = inject(DeviceService);
    private authService = inject(AuthService);
  

  public user$ = computed(() => this.authService.currentUser());
    private ms = inject(MessageService);
  
    async prepararFichaje() {
      this.fichando = true;
      this.horaActual = new Date();
      const [locationStr, ip, deviceInfo] = await Promise.all([
        this.deviceService.getLocation(),
        this.deviceService.getPublicIP(),
        Promise.resolve(this.deviceService.getDeviceInfo())
      ]);
    
      this.location = locationStr;
      this.ip = ip;
      this.deviceInfo = deviceInfo;
        }

  calculateTimeDifference(): string {
    const startDate = new Date(this.lastFichaje.date);
    const endDate = new Date();
    if (!startDate || !endDate) {
      return '';
    }

    const date1 = new Date(startDate);
    const date2 = new Date(endDate);

    const differenceInMilliseconds = Math.abs(
      date1.getTime() - date2.getTime()
    );
    const differenceInHours = Math.floor(
      differenceInMilliseconds / (1000 * 60 * 60)
    );
    const differenceInMinutes = Math.floor(
      (differenceInMilliseconds % (1000 * 60 * 60)) / (1000 * 60)
    );

    const hoursString =
      differenceInHours > 0
        ? `${differenceInHours} hora${differenceInHours > 1 ? 's' : ''}`
        : '';
    const minutesString =
      differenceInMinutes > 0
        ? `${differenceInMinutes} minuto${differenceInMinutes > 1 ? 's' : ''}`
        : '';

    if (hoursString && minutesString) {
      return `${hoursString} y ${minutesString}`;
    } else if (hoursString) {
      return hoursString;
    } else if (minutesString) {
      return minutesString;
    } else {
      return '0 minutos';
    }
  }

  async ngOnInit() {
    await this.prepararFichaje();
    this.isLoading.set(false);
  }

  async handleFichaje() {
    const session: FichajeSessionEvent = {
      type: 'fichaje',
      date: this.horaActual.getTime(),
      userId: this.user$()!.uid,
      storeId: this.lastFichaje.storeId || this.user$()?.current_store!,
      action: 'endwork',
      location: this.location,
      deviceInfo: this.deviceInfo,
      ip: this.ip,
      manualOverride: false
    }
    this.isUploading = true;
    try {
      const res = await this.fichajeService.registrarFichaje(session);
      if(res) {
        this.onDrawerlose.emit(true);
        this.ms.add({severity:'success', summary:'Fichaje', detail:'El fichaje ha sido registrado'});
      } else {
        this.ms.add({severity:'error', summary:'Error', detail:'Ha ocurrido un error al registrar el fichaje'});
      }
      this.isUploading = false;
    } catch (error) {
      this.ms.add({severity:'error', summary:'Error', detail:'Ha ocurrido un error al registrar el fichaje'});
      this.isUploading = false;
    }
  }


}
